module.exports = __webpack_public_path__ + "static/media/sombra-lombada-interna.88c02d00.svg";